"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrap = unwrap;
function unwrap(strings, ...values) {
    // Reassemble the template: chunk, value, chunk, value, ..., chunk
    const raw = strings.reduce((acc, chunk, i) => acc + chunk + (i < values.length ? String(values[i]) : ""), "");
    return raw.replace(/\s+/g, " ").trim();
}
//# sourceMappingURL=unwrap.js.map